import React from "react";
import "./Contact.css";

const Contact = () => {
  return (
    <section className="contact-section">
      <div className="contact-container">
        {/* Contact Form */}
        <div className="contact-form">
        <h2
          className="text-center mb-4"
          style={{
            letterSpacing: "1px",
            wordSpacing: "2px",
            color: "#002D62", // Dark blue
          }}
        >
          <strong>
           Request a  <span style={{ color: "#00AEEF" }}>Call Back</span>
          </strong>
        </h2>
          <form
            action="https://formsubmit.co/a4d2466842986206e0058e8e50bbf187"
            method="POST"
          >
            <input type="hidden" name="_subject" value="New email" />
            <input type="text" name="name" placeholder="Full Name" required />
            <input type="email" name="email" placeholder="Email" required />
            <input
              type="tel"
              name="phone"
              placeholder="Phone number"
              required
            />
            <textarea name="message" placeholder="Message" required></textarea>
            <button type="submit">SEND</button>
          </form>
        </div>

        {/* Map Section */}
        <div className="contact-map">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15242.748283995393!2d80.45688585!3d16.42939315!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a35e88849666667%3A0x6a2c3587b640854d!2sMangalagiri%2C%20Andhra%20Pradesh!5e0!3m2!1sen!2sin!4v1705664448575!5m2!1sen!2sin"
            width="100%"
            height="450"
            style={{ border: "none", borderRadius: "8px" }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Map of Mangalagiri, Andhra Pradesh"
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default Contact;
